import { render } from "./TournamentRoomDetailView.vue?vue&type=template&id=1256e9b2"
import script from "./TournamentRoomDetailView.vue?vue&type=script&lang=js"
export * from "./TournamentRoomDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__